import { render, staticRenderFns } from "./Rezultati.vue?vue&type=template&id=3f1ef0b1&scoped=true&"
import script from "./Rezultati.vue?vue&type=script&lang=js&"
export * from "./Rezultati.vue?vue&type=script&lang=js&"
import style0 from "./Rezultati.vue?vue&type=style&index=0&id=3f1ef0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ef0b1",
  null
  
)

export default component.exports